import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Brand } from '../../components/Brand'
import { adminApi } from '../../lib/api'
import { supabase } from '../../lib/supabase'

export function AdminLogin() {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')
  const navigate = useNavigate()

  const submit = async (e: React.FormEvent) => {
    e.preventDefault(); setLoading(true); setError('')
    try {
      const { error: authError } = await supabase.auth.signInWithPassword({ email, password })
      if (authError) throw authError
      if (!(await adminApi.isAdmin())) {
        await supabase.auth.signOut()
        throw new Error('Este usuário não possui permissão administrativa.')
      }
      navigate('/admin', { replace: true })
    } catch (err) { setError(err instanceof Error ? err.message : 'Falha no login.') }
    finally { setLoading(false) }
  }

  return <div className="admin-login"><div className="admin-login__card"><Brand /><h1>PAINEL ADMINISTRATIVO</h1><form onSubmit={submit}><label>Email<input type="email" required value={email} onChange={e => setEmail(e.target.value)} /></label><label>Senha<input type="password" required value={password} onChange={e => setPassword(e.target.value)} /></label>{error && <div className="form-error">{error}</div>}<button className="button button--dark button--full" disabled={loading}>{loading ? 'ENTRANDO...' : 'ENTRAR'}</button></form></div></div>
}
